import React, { useState, useEffect } from "react";
import { ObservableContainer } from "./SectionObserver.styles";

export const Observable = ({ Item }) => {
  const [visible, setVisible] = useState(false);
  let observer;
  let container;
  let prevRatio = 0;

  useEffect(() => {
    observer = new IntersectionObserver(observe, {
      threshold: 0.2,
      rootMargin: "140px",
    });

    observer.observe(container);

    return () => {
      observer.unobserve(container);
    };
  }, []);

  const observe = (entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio >= prevRatio) {
        const id = setTimeout(() => {
          const entry = entries.slice(0).shift();
          setVisible(entry.isIntersecting);
          clearTimeout(id);
        });
      }

      prevRatio = entry.intersectionRatio;
    });
  };

  return (
    <ObservableContainer ref={(node) => (container = node)}>
      <Item key={visible}></Item>
    </ObservableContainer>
  );
};
